import { useUpdateStartingBid } from 'hooks/useUpdateStartingBid';
import { Field, useField } from 'react-final-form';
import { FormFormattedField } from 'components/Form';
import { normalizeFormattedField } from 'utils';
import { useCallback } from 'react';
import { useSelectedAuction } from '../hooks/useSelectedAuction';
import { AUCTION_TYPES } from 'constants';

type Props = {
  vehicleId: number;
};

const reserveValidation = (value: any, formValues: any) => {
  const isAlternativeAuction = formValues.auctionId?.label && !formValues.auctionId.label.startsWith('#AA');
  const isScAuction = formValues.auctionId?.label && formValues.auctionId.label.startsWith('#SC');

  if (value == null || value === '') return isScAuction ? 'Required' : undefined;
  const parsed = typeof value === 'number' ? value : Number(value.trim());
  const currentStartingBid = formValues.starting_bid ? Number(formValues.starting_bid) : null;
  const alternativeOffer = isAlternativeAuction && formValues.aaCounter ? Number(formValues.aaCounter) : null;

  if (parsed <= 100) return 'Reserve price should be higher than starting bid';
  if (currentStartingBid && parsed <= currentStartingBid) return 'Reserve price should be higher than starting bid';

  if (alternativeOffer && parsed > alternativeOffer) return 'Reserve price should be lower then counter';
  return undefined;
};

export const ReservePriceField = ({ vehicleId }: Props) => {
  const {
    input: { value: reservePrice },
    meta: { dirty: reservePriceChanged }
  } = useField('aaCounter');

  const {
    input: { onChange: changeStartingBid }
  } = useField('starting_bid');

  const selectedAuctionType = useSelectedAuction(vehicleId);

  const isScAuction = selectedAuctionType === AUCTION_TYPES.SECOND_CHANCE;

  const updater = useCallback((newStartingBid: number) => changeStartingBid(newStartingBid), []);

  useUpdateStartingBid(reservePrice, updater, {
    skip: !isScAuction || !reservePriceChanged
  });

  return (
    <Field
      label="New Reserve"
      name="reserve_price"
      component={FormFormattedField}
      parse={normalizeFormattedField}
      prefix="$"
      validate={reserveValidation}
      thousandSeparator
      styleVariant="filled"
    />
  );
};
